/**
 * GameLeaderboardTrophy — the amber trophy that opens the leaderboard sheet from the warmup hub
 * header. Inline SVG (no lucide dependency → no Storybook icon-mock tax). Static (no glow).
 */

import { Pressable } from 'react-native';
import { Svg, Path } from 'react-native-svg';
import { gameLeaderboardTrophyStyles as styles } from './GameLeaderboardTrophy.styles';
import { GAME_LB_COLORS, GAME_LB_TEST_IDS } from './GameLeaderboardSheet.constants';

interface GameLeaderboardTrophyProps {
  onPress: () => void;
}

export function GameLeaderboardTrophy({ onPress }: GameLeaderboardTrophyProps) {
  return (
    <Pressable
      onPress={onPress}
      hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
      style={({ pressed }) => [styles.button, pressed && styles.pressed]}
      accessibilityRole="button"
      accessibilityLabel="Leaderboards"
      testID={GAME_LB_TEST_IDS.trophy}
    >
      <Svg width={22} height={22} viewBox="0 0 24 24" fill="none">
        <Path d="M8 4h8v3a4 4 0 01-8 0V4z" fill={GAME_LB_COLORS.trophyGlyph} />
        <Path
          d="M8 5H5v1.5A2.8 2.8 0 008 9M16 5h3v1.5A2.8 2.8 0 0116 9"
          stroke={GAME_LB_COLORS.trophyGlyph}
          strokeWidth={1.5}
        />
        <Path d="M12 11v3M9 19h6l-.7-3.4H9.7L9 19z" fill={GAME_LB_COLORS.trophyGlyph} />
      </Svg>
    </Pressable>
  );
}
